export default __webpack_public_path__ + "static/media/business_inactive.249509bd.svg";